import type { AmountInputProps } from '../../types/wallet-management'
import classNames from '../../utils/classNames'
import { numberWithCommas } from '../../utils/number'
import { useBoundStore } from '../../store/store'

interface AmountSelectorProps
  extends Pick<AmountInputProps, 'amount' | 'setAmount'> {
  amounts: number[]
  badges?: string[]
}

const AmountBadge = ({ label }: { label?: string }) => {
  if (!label) return null
  return (
    <span className="absolute -top-1 -right-1 z-10 flex items-center">
      <span
        className="h-0 w-0"
        style={{
          borderTop: '7px solid transparent',
          borderBottom: '7px solid transparent',
          borderRight: '4px solid #E91E63',
        }}
      />
      <span className="bg-[#E91E63] text-white text-[8px] font-bold px-1 py-[1px] rounded-r-sm xl:text-[10px]">
        {label}
      </span>
    </span>
  )
}

const AmountSelector = ({
  amount,
  setAmount,
  amounts,
  badges,
}: AmountSelectorProps) => {
  const theme = useBoundStore(state => state.common.theme)
  return (
    <div className="grid grid-cols-3 gap-2">
      {amounts.map((item, index) => {
        const isSelected = +amount.replace(/[^0-9.]/g, '') === item
        return (
          <button
            key={index}
            onClick={() => setAmount(numberWithCommas(item))}
            className={classNames(
              'relative text-sm py-2 rounded-md border border-solid transition-all duration-200 xl:text-base xl:py-3 dark:bg-[#181818] dark:border-[rgba(255,255,255,0.10)] dark:rounded-lg',
              isSelected
                ? 'deposit-chip-active border-highlight text-highlight dark:!border-[#f5c542] dark:!text-[#f5c542] dark:shadow-[0_0_14px_rgba(245,197,66,0.13)]'
                : 'border-secondary-txt-20 text-txt',
            )}
            style={
              isSelected && theme === 'light'
                ? {
                    background:
                      'linear-gradient(to bottom, color-mix(in srgb, var(--highlight) 5%, transparent))',
                  }
                : undefined
            }>
            <AmountBadge label={badges?.[index]} />
            {numberWithCommas(item)}
          </button>
        )
      })}
    </div>
  )
}

export default AmountSelector
